import {getProductId, Product} from '../../../../../models/clare';

/**
 * Holds selection state for the choose-bundle-products modal across pages.
 * Tracks selected products and selected product IDs across pages.
 */
export class BundleSelectionState {
  private selectedProductIds = new Set<string>();
  private selectedProductIdsSnapshot = new Set<string>();
  private selectedProducts: Product[] = [];

  getSelectedProducts(): Product[] {
    return this.selectedProducts;
  }

  getSelectedProductIds(): Set<string> {
    return this.selectedProductIds;
  }

  getSelectedProductIdsSnapshot(): Set<string> {
    return this.selectedProductIdsSnapshot;
  }

  /**
   * Merges the current page's selection with existing selections and returns the updated product array.
   */
  mergeSelectionFromPage(productsFromPage: Product[], currentPageProductIds: string[]): Product[] {
    const newSelectedIds = new Set(productsFromPage.map(p => getProductId(p) || ''));

    currentPageProductIds.forEach(id => this.selectedProductIds.delete(id));
    newSelectedIds.forEach(id => {
      if (id) {
        this.selectedProductIds.add(id);
      }
    });

    const updated = this.selectedProducts.filter(p => {
      const productId = getProductId(p) || '';
      return !currentPageProductIds.includes(productId);
    });
    updated.push(...productsFromPage);
    this.selectedProducts = updated;
    this.updateSelectedProductIdsSnapshot();
    return this.selectedProducts;
  }

  setSelectedProducts(products: Product[]): void {
    this.selectedProducts = products ?? [];
    this.selectedProductIds.clear();
    this.selectedProducts.forEach(p => {
      const id = getProductId(p) || '';
      if (id) {
        this.selectedProductIds.add(id);
      }
    });
    this.updateSelectedProductIdsSnapshot();
  }

  reset(existingProducts?: Product[]): void {
    this.selectedProductIds.clear();
    this.selectedProducts = existingProducts && existingProducts.length > 0 ? [...existingProducts] : [];
    if (this.selectedProducts.length > 0) {
      this.selectedProducts.forEach(p => {
        const id = getProductId(p) || '';
        if (id) {
          this.selectedProductIds.add(id);
        }
      });
    }
    this.updateSelectedProductIdsSnapshot();
  }

  private updateSelectedProductIdsSnapshot(): void {
    this.selectedProductIdsSnapshot = new Set(this.selectedProductIds);
  }
}
